import { chauffeurActivityConstants } from '@constants/chauffeurActivity.constants';

const initialState = {
  isFetchingChauffeurActivity: false,
  formChauffeurActivity: null,
  chauffeurActivity: null,

  isFetchingChauffeurActivities: false,
  isFetchingChauffeurActivitiesFrom: 0,
  chauffeurActivitiesTotalResults: 0,
  chauffeurActivitiesLoaded: 0,
  chauffeurActivities: [],
};

export default function chauffeurActivity(state = initialState, action) {
  switch (action.type) {
    case chauffeurActivityConstants.CHAUFFEURTIMESLOT_CHANGE_VALUE:
      return { ...state, error: '', [action.name]: action.value };

    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOT_STARTED:
      return { ...state, isFetchingChauffeurActivity: true };
    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOT_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: null,
        error: action.message || '',
      };
    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOT_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: action.chauffeurActivity,
      };

    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOTS_STARTED:
      return {
        ...state,
        isFetchingChauffeurActivities: true,
        isFetchingChauffeurActivitiesFrom: action.from || 0,
      };
    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOTS_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivities: false,
        chauffeurActivities: [],
        error: action.message || '',
      };
    case chauffeurActivityConstants.GET_CHAUFFEURTIMESLOTS_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivities: false,
        chauffeurActivities:
          state.chauffeurActivities?.length > 0
            ? [...state.chauffeurActivities, ...action.chauffeurActivities]
            : action.chauffeurActivities,
        chauffeurActivitiesLoaded:
          action.from > 0
            ? state.chauffeurActivities?.length + action.chauffeurActivities?.length
            : action.chauffeurActivities?.length,
        chauffeurActivitiesTotalResults: action.totalResults || 0,
      };

    case chauffeurActivityConstants.SEARCH_CHAUFFEURTIMESLOTS_STARTED:
      return {
        ...state,
        isFetchingChauffeurActivities: true,
        isFetchingChauffeurActivitiesFrom: action.from || 0,
      };
    case chauffeurActivityConstants.SEARCH_CHAUFFEURTIMESLOTS_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivities: false,
        chauffeurActivities: [],
        error: action.message || '',
      };
    case chauffeurActivityConstants.SEARCH_CHAUFFEURTIMESLOTS_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivities: false,
        chauffeurActivities:
          action.from > 0
            ? [...state.chauffeurActivities, ...action.chauffeurActivities]
            : action.chauffeurActivities,
        chauffeurActivitiesLoaded:
          action.from > 0
            ? state.chauffeurActivities?.length + action.chauffeurActivities?.length
            : action.chauffeurActivities?.length,
        chauffeurActivitiesTotalResults: action.totalResults || 0,
      };

    case chauffeurActivityConstants.CREATING_CHAUFFEURTIMESLOT_STARTED:
      return { ...state, isFetchingChauffeurActivity: true };
    case chauffeurActivityConstants.CREATING_CHAUFFEURTIMESLOT_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: null,
        error: action.message || '',
      };
    case chauffeurActivityConstants.CREATING_CHAUFFEURTIMESLOT_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: action.chauffeurActivity,
        chauffeurActivities: [
          action.chauffeurActivity,
          ...state.chauffeurActivities,
        ],
      };

    case chauffeurActivityConstants.UPDATING_CHAUFFEURTIMESLOT_STARTED:
      return { ...state, isFetchingChauffeurActivity: true };
    case chauffeurActivityConstants.UPDATING_CHAUFFEURTIMESLOT_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: null,
        error: action.message || '',
      };
    case chauffeurActivityConstants.UPDATING_CHAUFFEURTIMESLOT_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: action.chauffeurActivity,
        chauffeurActivities: [...state.chauffeurActivities]?.map(
          (chauffeurActivity) => {
            if (action.chauffeurActivity.id === chauffeurActivity.id) {
              return action.chauffeurActivity;
            }
            return chauffeurActivity;
          }
        ),
      };

    case chauffeurActivityConstants.DELETE_CHAUFFEURTIMESLOT_STARTED:
      return { ...state, isFetchingChauffeurActivity: true };
    case chauffeurActivityConstants.DELETE_CHAUFFEURTIMESLOT_FAILURE:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: null,
        message: action.message || '',
      };
    case chauffeurActivityConstants.DELETE_CHAUFFEURTIMESLOT_SUCCESS:
      return {
        ...state,
        isFetchingChauffeurActivity: false,
        chauffeurActivity: action.chauffeurActivity,
        chauffeurActivities: [...state.chauffeurActivities].filter(
          (chauffeurActivity) =>
            action.chauffeurActivity.id !== chauffeurActivity.id
        ),
      };
    default:
      return state;
  }
}
